import React from "react"
import Row from "antd/lib/row"
import Collapse from "antd/lib/collapse"
import Input from "antd/lib/input/Input"
import Form from "antd/lib/form"
import Col from "antd/lib/col"

interface FilterInputInterface {
    header: string
    name: string
    initialValue: any
    keyCode?: string
    label?: string
    placeholder?: string
    onChange?: any
}

export default function FilterInput({ header, name, initialValue, placeholder, label, onChange, keyCode = "0" }: FilterInputInterface) {
    return (
        <Collapse ghost defaultActiveKey={keyCode}>
            <Collapse.Panel header={header} key={keyCode}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item name={name} label={label} className="mb-0" initialValue={initialValue}>
                            <Input placeholder={placeholder} onChange={onChange} />
                        </Form.Item>
                    </Col>
                </Row>
            </Collapse.Panel>
        </Collapse>
    )
}
